<template>
  <input-base
    :input="input"
    :review-mode="reviewMode"
    :error="error"
  >
    <div
      v-if="!input.attributes.locked && !reviewMode"
      class="flex-1 mt-1"
    >
      <input
        :id="input.key + (applicationValueIndex ? '_' + applicationValueIndex : '')"
        ref="input"
        class="w-full"
        :type="input.type"
        :name="input.key + (applicationValueIndex ? '_' + applicationValueIndex : '')"
        :value="applicationValue"
        autocomplete="off"
        :placeholder="input.attributes.placeholder"
        :readonly="input.attributes.locked || reviewMode"
        :required="input.attributes.required"
        @input="updateInput(parentField, input.key, $event.target.value)"
        v-on="$listeners"
      >
    </div>
    <span
      v-else
      ref="input-locked"
      class="flex-1"
    >
      {{ formattedValue }}
    </span>
  </input-base>
</template>

<script>
import { inputHelperMixin } from '../../mixins/inputHelper';
export default {
	name: 'InputDefault',
	mixins: [inputHelperMixin],
	computed: {
		formattedValue() {
			let av = this.applicationValue;
			return (av !== null && !isNaN(this.applicationValue) )
							? av.toLocaleString()
							: (this.input.type !== 'number')
								? av
								: "";
		}
  },
  beforeUpdate(){
    this.setAttrs();
  },
	mounted() {
		this.setAttrs();
  },
  methods: {
    setAttrs() {
      const $el = this.$refs.input;
      if($el) {
        if(this.input.type === 'text') {
          if( this.input.validation.hasOwnProperty('limit') ) {
            $el.setAttribute('maxlength', this.input.validation.limit)
          }
        }

        if(this.input.type === 'number' || this.input.type === 'date') {
          if( this.input.validation.hasOwnProperty('min') ) {
            $el.setAttribute('min', this.input.validation.min)
          }
          if( this.input.validation.hasOwnProperty('max') ) {
            $el.setAttribute('max', this.input.validation.max)
          }
        }
        if(this.input.type === 'number')
          if( this.input.validation.hasOwnProperty('step') ) {
            $el.setAttribute('step', this.input.validation.step)
          } else {
            $el.setAttribute('step', '0.01')
          }
        }
      }
    }
}
</script>
